<template>
  <div class="row">
    <div class="col-lg-4">
      <div class="sidebar-left w-100">
        <div class="sidebar">
          <div
              class="sidebar-content w-100"
          >
            <!-- Header -->
            <div class="chat-fixed-search w-100">
              <div class="d-flex align-items-center w-100">
                <!-- Search -->
                <b-input-group class="input-group-merge w-100 round">
                  <b-input-group-prepend is-text>
                    <feather-icon
                        icon="SearchIcon"
                        class="text-muted"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                      v-model="searchQuery"
                      placeholder="Поиск..."
                  />
                </b-input-group>
              </div>
            </div>

            <!-- ScrollArea: Chat & Contacts -->
            <vue-perfect-scrollbar
                :settings="perfectScrollbarSettings"
                class="chat-user-list-wrapper list-group w-100 scroll-area"
            >

              <!-- Chats Title -->
              <h4 class="mt-4 chat-list-title">
                Студенты
              </h4>

              <!-- Chats -->
              <ul class="chat-users-list chat-list media-list">
                <li v-for="student in studentsWithGroup"
                    @click="chooseStudent(student.id)"
                    class="chat-info flex-grow-1"
                    :class="{'active': student.id === activeStudent}"
                >
                  <h5 class="mb-0">
                    {{ student.name }} - {{ student.email }}
                  </h5>
                  <p class="card-text text-truncate">
                  </p>
                </li>
              </ul>
            </vue-perfect-scrollbar>
          </div>

        </div>
      </div>
    </div>
    <div v-if="$route.params.id" class="col-lg-8">
      <vue-good-table
          :columns="columns"
          :rows="transactions"
          :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      >
        <template
            slot="table-row"
            slot-scope="props"
        >

          <!-- Column: Name -->
          <span v-if="props.column.field === 'user_id'">
          <b-badge>
            {{ getModelName('students', props.row.user_id, 'name') }}
          </b-badge>
        </span>

          <!-- Column: Common -->
          <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
        </template>

        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
              <b-form-select
                  v-model="pageLength"
                  :options="['3','5','10']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap "> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BInputGroup,
  BInputGroupPrepend,
  BPagination,
  BFormSelect
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import WorkingHoursInput from "@/components/TeacherSchedule/WorkingHoursInput";
import {createNamespacedHelpers} from 'vuex'
import CRMApi from '@/api/crm';
import formattedDate from '@/mixins/formattedDate'


const {mapState, mapActions, mapGetters} = createNamespacedHelpers('crm')

export default {
  components: {
    WorkingHoursInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormGroup,
    BInputGroupPrepend,
    BFormInput,
    BInputGroup,
    BButton,
    VuePerfectScrollbar,
    VueGoodTable,
    BPagination,
    BFormSelect
  },
  mixins: [formattedDate],
  name: "index",
  computed: {
    ...mapState({
      students: state => state.students
    }),
    ...mapGetters(['studentsWithGroup']),
  },
  data() {
    return {
      pageLength: 10,
      form: {},
      chosenDays: [],
      filledTime: {},
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
      searchQuery: '',
      activeChatContactId: '',
      activeStudent: null,
      studentData: {},
      columns: [
        {
          label: 'id',
          field: 'id'
        },
        {
          label: 'Id Вебинара',
          field: 'webinar_id'
        },
        {
          label: 'Сумма',
          field: 'amount'
        }
      ],
      transactions: [],
    }
  },
  methods: {
    ...mapActions(['getUsers']),
    chooseStudent(id) {
      this.$router.push({name: 'admin.payments.inner', params: {id: id}})
    },
    uploadRoutes() {
      if (this.$route.name === 'admin.payments.inner') {
        CRMApi.getStudentPayments(this.$route.params.id)
            .then(res => {
              this.activeStudent = res.data[0].user_id
              this.transactions = res.data
            })
            .catch(err => {
              console.log(err);
              this.$bvToast.toast('Please try again later', {
                title: `Oops! Something went wrong...`,
                variant: 'danger',
                solid: true,
              })
            })
      }
    }
  },
  watch: {
    '$route'(to) {
      this.uploadRoutes()
    }
  },
  created() {
    this.getUsers();
    this.uploadRoutes();

  },
}
</script>

<style lang="scss" scoped>
.chat-users-list {
  height: 80vh;
  padding-left: 0;
  list-style-type: none;

  .chat-info {
    padding: 10px;
    cursor: pointer;

    &.active {
      background: #ffbd3b;

      h5 {
        color: #fff;
      }
    }
  }
}

.dark-layout {
  .chat-fixed-search {
    background-color: #283046;
  }

  .chat-user-list-wrapper {
    background-color: #283046;
  }
}
</style>
